module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAPCAYAAACyTgIjAAAAPElEQVRYhe3QsQ3AIADAMOD/n4G1UnY62BdEmfsafKzXAX9kSjAlmBJMCaYEU4IpwZRgSjAlmBJMCaaEA6idBBpxcDUVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwpstb7.png
// module id = 94
// module chunks = 0